import { CandidateEvaluationFeedback } from '../candidateEvaluationFeedback';
import { ScheduleInterview } from '../scheduleInterview';


export class SaveCandidateEvaluationFeedbackSerializer {
    fromJson(json: any): CandidateEvaluationFeedback {
        return json;
    }

    toJson(data: ScheduleInterview): any {
        return data
    }
}